import { GetSimListParams, SimOverview } from "@/services/model";
import { PORTAL_SIM_PRIORITY_FETCH_CAP } from "@/utils/simDisplayPriority.ts";

export const PORTAL_SIM_LIST_PAGE_SIZE = 10;
export const PORTAL_SIM_LIST_STALE_TIME_MS = 2 * 60 * 1000;

/** Default Plans / Cockpit SIM list params — aligned with the priority-sort fetch cap. */
export const getDefaultPortalSimListParams = (): GetSimListParams => ({
  pageSize: PORTAL_SIM_PRIORITY_FETCH_CAP,
});

export const getPortalSimListNextPageParam = (
  lastPage: SimOverview | undefined,
  allPages: SimOverview[],
) => {
  if (
    lastPage?.totalNumberPages &&
    allPages.length < lastPage.totalNumberPages
  ) {
    return allPages.length;
  }

  return undefined;
};

export const portalSimListInfiniteQueryOptions = {
  staleTime: PORTAL_SIM_LIST_STALE_TIME_MS,
  refetchOnWindowFocus: false,
  getNextPageParam: getPortalSimListNextPageParam,
};
